import { create } from 'zustand'

type ArticleSearchHistory = {
    knowHowAndTip: string | null
    news: string | null
    promotion: string | null
    setKnowHowAndTip: (search: string | null) => void;
    setNews: (search: string | null) => void;
    setPromotion: (search: string | null) => void;
    resetKnowHowAndTip: () => void;
    resetNews: () => void;
    resetPromotion: () => void;
}

export const ArticleSearchHistoryStore = create<ArticleSearchHistory>((set) => ({
  knowHowAndTip: null,
  news: null,
  promotion: null,
  setKnowHowAndTip: (search) => set(() => ({knowHowAndTip: search })),
  setNews: (search) => set(() => ({news: search })),
  setPromotion: (search) => set(() => ({promotion: search })),
  resetKnowHowAndTip: () => set({knowHowAndTip: null}),
  resetNews: () => set({news: null}),
  resetPromotion: () => set({news: null}),
}))